import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { analysesApi } from "@/lib/api";
import KpiCard from "@/components/KpiCard";

const ODD_LABELS = {
  ODD1: "Fin de la pauvreté",
  ODD2: "Faim zéro",
  ODD3: "Bonne santé",
  ODD4: "Éducation de qualité",
  ODD6: "Eau propre",
  ODD8: "Travail décent",
  ODD10: "Inégalités réduites",
  ODD16: "Justice & institutions",
};

const COLOR = { rouge: "bg-alert text-white", orange: "bg-warn text-white", neutre: "bg-muted text-foreground", vert: "bg-success text-white" };

export default function OddAnalysis() {
  const { projectId } = useParams();
  const [odd, setOdd] = useState(null);

  useEffect(() => { analysesApi.odd(projectId).then(setOdd); }, [projectId]);

  if (!odd) return <div className="p-10 label-mono text-xs text-muted-foreground">Chargement…</div>;

  return (
    <div className="px-6 lg:px-10 py-8 max-w-6xl mx-auto w-full" data-testid="odd-page">
      <div className="label-mono text-[10px] text-muted-foreground">MODULE 2.4</div>
      <h1 className="mt-1 font-serif font-bold text-4xl">Impact développemental — ODD</h1>
      <p className="mt-2 text-muted-foreground text-sm max-w-2xl">
        Matrice d'impact automatique dérivée des conditionnalités extraites. Les couleurs signalent l'impact
        potentiel sur chaque Objectif de Développement Durable.
      </p>

      <div className="mt-6">
        <KpiCard label="CONDITIONNALITÉS IDENTIFIÉES" value={odd.conditionalities_count} format="int" />
      </div>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
        {Object.entries(ODD_LABELS).map(([k, l]) => {
          const cell = odd.matrix[k];
          return (
            <div key={k} className="border border-border bg-card rounded-sm overflow-hidden">
              <div className={`h-2 ${cell ? COLOR[cell.color] : "bg-muted"}`} />
              <div className="p-4">
                <div className="label-mono text-[9px] text-muted-foreground">{k}</div>
                <div className="font-serif font-bold mt-0.5">{l}</div>
                <div className="mt-3 text-xs">
                  {cell ? (
                    <span>
                      Impact <strong className="uppercase">{cell.color}</strong>
                      <span className="text-muted-foreground"> · {cell.occurrences} occ.</span>
                    </span>
                  ) : <span className="text-muted-foreground">Aucun impact identifié</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
